import React from 'react'
import AnimatedText7 from './AnimatedText7'
import iconorange from '../images/icon_orange.svg';

import menprofile from '../images/menprofile.webp';

const ProfileSection = () => {
  return (
    <div>
                <section id="profile">
                <div className='container-xxl profile-container'>
                    <div className='row profilerow'>
                        <div className='col-md-6 colleft'>
                            <div className='content-box' >
                                <div className='text-box' data-aos="fade-up" data-aos-once="true">
                                    <img id="profileimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                                    <p>Founder of DesignLanders</p>
                                </div>

                                <AnimatedText7 />
                                <p >I am Sudhanshu Batra, A versatile Shopify Developer, and Designer who have worked for over 8+ years to provide the best E-commerce websites. I am also a Certified Replo developer.</p>
                                <ul >
                                    <li>
                                        <div className='text-li'>

                                            <div className='icon'>
                                                <svg
                                                    stroke="#FE7201FF" fill="#FE7201FF"
                                                    stroke-width="0" viewBox="0 0 16 16"
                                                    role="presentation" class="r-1qz24ta"
                                                    height="1.3em" width="1.3em"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                    <path
                                                        d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                        fill="white"
                                                    ></path>
                                                </svg>
                                            </div>

                                            <div className='txt'>
                                                <p> TOP-RATED on Upwork</p>
                                            </div>
                                        </div>
                                    </li>


                                    <li>
                                        <div className='text-li'>
                                            <div className='icon'>
                                                <svg
                                                    stroke="#FE7201FF" fill="#FE7201FF"
                                                    stroke-width="0" viewBox="0 0 16 16"
                                                    role="presentation" class="r-1qz24ta"
                                                    height="1.3em" width="1.3em"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                    <path
                                                        d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                        fill="white"
                                                    ></path>
                                                </svg>
                                            </div>
                                            <div className='txt'>
                                                <p>All 5 star Ratings Achieved</p>
                                            </div>
                                        </div>
                                    </li>


                                    <li>
                                        <div className='text-li'>
                                            <div className='icon'>
                                                <svg
                                                    stroke="#FE7201FF" fill="#FE7201FF"
                                                    stroke-width="0" viewBox="0 0 16 16"
                                                    role="presentation" class="r-1qz24ta"
                                                    height="1.3em" width="1.3em"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                    <path
                                                        d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                        fill="white"
                                                    ></path>
                                                </svg>
                                            </div>
                                            <div className='txt'>
                                                <p>40+ Jobs Completed Successfully on Upwork</p>
                                            </div>
                                        </div>
                                    </li>


                                    <li>
                                        <div className='text-li'>
                                            <div className='icon'>
                                                <svg
                                                    stroke="#FE7201FF" fill="#FE7201FF"
                                                    stroke-width="0" viewBox="0 0 16 16"
                                                    role="presentation" class="r-1qz24ta"
                                                    height="1.3em" width="1.3em"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                    <path
                                                        d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                        fill="white"
                                                    ></path>
                                                </svg>
                                            </div>
                                            <div className='txt'>
                                                <p>100% Job Success Rate</p>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                                <button className='btnhire'>
                                    
                                    <a
                                    href="https://www.upwork.com/freelancers/~0125e50dfd12cf8421"
                                    target='_blank'
                                    rel="noreferrer" 
                                    >Hire Now</a>
                                </button>
                            </div>
                        </div>
                        <div className='col-md-6 colright'>
                            <div className='image-box'>
                                <img alt='menprofile' src={menprofile} />
                            </div>
                        </div>
                    </div>

                </div>
            </section>
    </div>
  )
}

export default ProfileSection